import React, { useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';

import { Typography, Link, Button, Box, Stack, Container, Alert, useMediaQuery, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import axios from "axios";
import BasicModal from './BasicModal';

import { questionNumberMap } from '../constants';

const CVESDIAComponents = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { examId } = useParams();
  const navigate = useNavigate();

  const [mathScore, setMathScore] = useState('');
  const [languageScore, setLanguageScore] = useState('');
  const [readingScore, setReadingScore] = useState('');
  const [timeLeft, setTimeLeft] = useState(9999);
  const [error, setError] = useState("");
  const [languageGraded, setLanguageGraded] = useState(false);
  const [readingGraded, setReadingGraded] = useState(false);
  const [mathGraded, setMathGraded] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const [blankQuestions, setBlankQuestions] = useState([]);
  const [pendingGrading, setPendingGrading] = useState(null);
  
  useEffect(() => {
    if (!examId) return;

    const token = localStorage.getItem("access_token");
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/exams/${examId}/handle_time_remaining`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then((response) => {
          setTimeLeft(response.data.time_remaining);
          localStorage.setItem('time_left',response.data.time_remaining);
        })
  }, [examId])

  useEffect(() => {
    if (!examId) return;
    const token = localStorage.getItem("access_token");
    //console.log(localStorage.getItem('exam_id'));
    if (token) {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/exams/${examId}/check_score/`,{
          component_type:'language'
        },{
          headers: {
            Authorization: `Bearer ${token}`
        }})
        .then((response) => {
          if (response.status === 200) {
              if (response.data.exam_scored === true) {
              console.log('language scored');
              setLanguageGraded(true);
              setLanguageScore(response.data.component_score);
              } else {
                console.log('Could not set language score');
              }
          } else {
            setError('Could not retrieve Language component scores.');
            console.log(response);
          };
        })
        .catch((error)=>{
          setError('Could not retrieve Language component scores.');
          console.log(error);
        }) 
      
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/exams/${examId}/check_score/`,{
          component_type:'math'
        },{
          headers: {
            Authorization: `Bearer ${token}`
        }})
        .then((response) => {
          if (response.status === 200) {
              if (response.data.exam_scored === true) {
              console.log('math scored');
              setMathGraded(true);
              setMathScore(response.data.component_score);
              } else {
                console.log('Could not set math score');
              }
          } else {
            setError('Could not retrieve Math component scores.');
          };
        })
        .catch((error)=>{
          setError('Could not retrieve Math component scores.');
        }) 

      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/exams/${examId}/check_score/`,{
          component_type:'reading'
        },{
          headers: {
            Authorization: `Bearer ${token}`
        }})
        .then((response) => {
          if (response.status === 200) {
              if (response.data.exam_scored === true) {
              console.log('reading scored',response.data.component_score);
              setReadingGraded(true);
              setReadingScore(response.data.component_score);
              } else {
                console.log('Could not set reading score');
              }
          } else {
            setError('Could not retrieve Reading component scores.');
          };
        })
        .catch((error)=>{
          setError('Could not retrieve Reading component scores.');
        }) 
    }
  }, [examId])

  const finalizeGrading = (component_type) => {
    console.log("FINALIZING...");
    const token = localStorage.getItem("access_token");
    if (token) {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/exams/${examId}/grade_component/`,{
          component_type: component_type,
          blank_questions_known: true
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (component_type === 'math') {
            setMathScore(response.data.percentage_correct);
            setMathGraded(true);
          } else if (component_type === 'language') {
            setLanguageScore(response.data.percentage_correct);
            setLanguageGraded(true);
          } else if (component_type === 'reading') {
            setReadingScore(response.data.percentage_correct);
            setReadingGraded(true);
          };
          setPendingGrading(null);
        
        })
        .catch((error) => console.error(error));
    }
  }
  
  const gradeComponent = (component_type) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/exams/${examId}/grade_component/`,{
          component_type: component_type,
          blank_questions_known: false
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data.blank_questions.length !== 0) {
            setBlankQuestions(response.data.blank_questions);
            setOpen(true);
            setPendingGrading({
              component_type,
              percentage_correct: response.data.percentage_correct
            });
            return;
          } 
          finalizeGrading(component_type)
        
        })
        .catch((error) => console.error(error));
    }
    
  };

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds/3600);
    const minutes = Math.floor((seconds / 60) % 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const openComponent = (component_type, destination) => {
    const token = localStorage.getItem("access_token");

    if (token) {
      if (timeLeft === 0) {
        setError('Your time has expired for this exam.  Please submit your scores then logout.')
      } else {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/exams/${examId}/check_score/`,{
          component_type: component_type,
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data.exam_scored === true) {
            setError('This exam component has alredy been scored.')
          } else {
            navigate(`/ia-sa-exam/${questionNumberMap[component_type]}/${component_type}`)
          }
        })
        .catch((error) => console.error(error));
    }};
  };

  const submitTitle = 'Grade Component?'
  const submitSubText = 'You will not be able to re-open this exam component if you grade it.'
  const submitButtonText = 'Grade'
  const submitStyle = {
    position: 'relative',
    p:2.5,
    fontWeight: 600,
    height: '45%',
    backgroundColor: "#D9D9D9",
    color: "#5E5E5E",
    "&:hover": { backgroundColor: "#c44601", color: "#FFFFFF" }
  }
  const submitLanguageComponent = () => {
    gradeComponent('language');
  }
  const submitMathComponent = () => {
    gradeComponent('math');
  }
  const submitReadingComponent = () => {
    gradeComponent('reading');
  }

  const outerBoxBigStyle = {display:'flex', flexDirection:'column', maxWidth:'90%', width:'100%',justifySelf:'center'};
  const outerBoxMobileStyle = {display:'flex', flexDirection:'column', maxWidth:'100%', width:'100%',justifySelf:'center'};

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '65vw',
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  }
  const mobileModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '65vw',
    maxWidth:'100vw',
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
    whiteSpace:'normal'
  }

  return (
    <Box sx={!isMobile ? (outerBoxBigStyle) : (outerBoxMobileStyle)}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{whiteSpace:'normal'}}
      >
      <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
        <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
        Unanswered Questions!
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb:2 }}>
        There are still questions that need to be answered: {blankQuestions.sort((a, b) => a - b).join(", ")}
        </Typography>
        <Stack direction={'row'} sx={{p:0, justifyContent:'space-between'}}>
        <Button variant='outlined' sx={{}} onClick={() => {handleClose()}}>Cancel</Button>
        <Button variant='contained' sx={{bgcolor:'#c44601'}} onClick={() => {
          handleClose()
          finalizeGrading(pendingGrading['component_type'])}}>Grade Anyways</Button>
        </Stack>
      </Box>
      </Modal>
      <Stack direction={'column'}>
      <Typography variant='h4' sx={{pb:2, color:'#054fb9', fontWeight:700}}>Instructions</Typography>
      <Box sx={{bgcolor:'#FAFAFA', mb:2, p:2, borderRadius:4}}>
        
        <Typography variant='h6'>Overview</Typography>
        <Typography variant='body1' sx={{fontSize:14}}>
          <ReactMarkdown>The _Instructional Assistant/Student Attendant Proficiency Exam_ is 
          made of three components: _**Language, Math, and Reading**_.  You will have __TWO HOURS TOTAL__ to complete all three components. _The timer will be shown in the top right of the testing window._
          </ReactMarkdown>
        </Typography>
        <Typography variant='h6'>Navigation and Flags</Typography>
        <Typography variant='body1' sx={{fontSize:14}}>
          <ReactMarkdown>
          The __*All Questions*__ button at the top-center of the testing
          window will open a panel that allows you to navigate to any question on the test.
          This panel will also show which questions you have flagged.  You can flag a question for review by clicking the _grey flag icon_ next to the question number at the top of the testing viewport; once clicked the flag will turn red. _This feature is for your convenience and has no effect on your score_.
          </ReactMarkdown>
        </Typography>
        <Typography variant='h6'>Multiple Choice</Typography>
        <Typography variant='body1' sx={{fontSize:14}}>
          <ReactMarkdown>
          Each component contains multiple choice questions. Click the 
          circle next to answer you wish to select. Your answer choices will __ONLY__ save when navigating between questions using the *__Prev__* and *__Next__* buttons, or the __*All Questions*__ panel.
          </ReactMarkdown>
        </Typography>
        <Typography variant='h6'>Images</Typography>
        <Typography variant='body1' sx={{fontSize:14}}>
          <ReactMarkdown>
          Some questions have an image that is necessary for context.
          Clicking the image will enlarge it.  Clicking the "X" in the top right of the screen or clicking
          off the image will close the enlarged view.
          </ReactMarkdown>
        </Typography>
 
        <Typography variant='h6'>Submission</Typography>
        <Typography variant='body1' sx={{fontSize:14}}>
          <ReactMarkdown>
          Clicking the __Complete Exam__ button on the last question will return
          you to this screen. Once you are finished you can press the __Grade__ button next to the exam component that you have completed to receive your score immediately.
          __YOU WILL NOT BE ABLE TO OPEN AN EXAM COMPONENT AGAIN ONCE YOU HAVE RECEIVED YOUR SCORE.__
          </ReactMarkdown>
        </Typography>

      </Box>
      </Stack>
      <Box sx={{display:'flex', flexDirection:'column',minWidth:'35%'}}>
        <Typography variant='h4' sx={{mb:1, color:'#054fb9', fontWeight:700}}>IA/SA Proficiency Exam Components</Typography>
        <Typography variant='body1' sx={{display:'flex', flexDirection:'row', mb:2}}>
          <Typography sx={{fontWeight:550, mr:1}}>Total Time Remaining: </Typography> {formatTime(timeLeft)}
        </Typography>
        {error && <Alert severity='error' sx={{mb:1}} onClose={() => {setError('')}}>{error}</Alert>}
        <Stack spacing={2} sx={{mb:4}}>
          <Box sx={{display:'flex', flexDirection:'row', bgcolor:'#EBEBEB', borderRadius:3, width:'100%'}}>
              {!isMobile && (
                <Box
                component="img"
                src="/images/language_cover.png"
                alt="speech box with letters 'abc' in front"
                sx={{ width: 100, height: 100, maxWidth: "100%",mr:2, bgcolor:'#8dd2dd', borderTopLeftRadius:13,borderBottomLeftRadius:13, p:2}}
              />
              )}
              <Box sx={{display:'flex', flexDirection:'row', p:2, width:'100%', justifyContent:'space-between'}}>
                <Box>
                  <Link variant='h5' underline='hover' sx={{fontWeight:500, cursor:'pointer'}} onClick={() => openComponent('language','languageComponent')}>
                      Language
                  </Link>
                  <Typography variant='body1' sx={{display:'flex', flexDirection:'row'}}>
                      <Typography sx={{fontWeight:550, mr:1}}>Questions: </Typography> 20
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  {languageScore!=='' && (
                    <Typography sx={{ color: languageScore >= 80 ? 'green' : 'red', fontWeight: 'bold' }}>
                      {languageScore >= 80 ? 'PASS' : 'FAIL'}
                    </Typography>
                  )}
                  {languageScore!=='' && <Typography sx={{ mb: 1 }}>{languageScore + '%'}</Typography>}
                  {!languageGraded && (<BasicModal title={submitTitle} subText={submitSubText} buttonFunction={submitLanguageComponent} buttonText={submitButtonText} buttonStlye={submitStyle}></BasicModal>)}
                </Box>
              </Box>
          </Box>
          <Box sx={{display:'flex', flexDirection:'row', bgcolor:'#EBEBEB', borderRadius:3, width:'100%'}}>
              {!isMobile && (
                <Box
                component="img"
                src="/images/math_cover.png"
                alt="Math operation symbols"
                sx={{ width: 100, height: 100, maxWidth: "100%",mr:2, bgcolor:'#90d8b2', borderTopLeftRadius:13,borderBottomLeftRadius:13, p:2}}
                />
              )}
              
              <Box sx={{display:'flex', flexDirection:'row', p:2, width:'100%', justifyContent:'space-between'}}>
                  <Box>
                    <Link variant='h5' underline='hover' sx={{fontWeight:500, cursor:'pointer'}} onClick={() => openComponent('math','mathComponent')}>
                        Math
                    </Link>
                    <Typography variant='body1' sx={{display:'flex', flexDirection:'row'}}>
                        <Typography sx={{fontWeight:550, mr:1}}>Questions: </Typography> 40
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  {mathScore!=='' && (
                    <Typography sx={{ color: mathScore >= 80 ? 'green' : 'red', fontWeight: 'bold' }}>
                      {mathScore >= 80 ? 'PASS' : 'FAIL'}
                    </Typography>
                  )}
                  {mathScore!=='' && <Typography sx={{ mb: 1 }}>{mathScore + '%'}</Typography>}
                  {!mathGraded && (<BasicModal title={submitTitle} subText={submitSubText} buttonFunction={submitMathComponent} buttonText={submitButtonText} buttonStlye={submitStyle}></BasicModal>)}
                </Box>
              </Box>
          </Box> 
          <Box sx={{display:'flex', flexDirection:'row', bgcolor:'#EBEBEB', borderRadius:3, width:'100%'}}>
            {!isMobile && (
              <Box
              component="img"
              src="/images/reading_cover.png"
              alt="An open book"
              sx={{ width: 100, height: 100, maxWidth: "100%",mr:2, bgcolor:'#b9e192', borderTopLeftRadius:13,borderBottomLeftRadius:13, p:2}}
              />
            )}
              
              <Box sx={{display:'flex', flexDirection:'row', p:2, width:'100%', justifyContent:'space-between'}}>
                <Box>
                  <Link variant='h5' underline='hover' sx={{fontWeight:500, cursor:'pointer'}} onClick={() => openComponent('reading','readingComponent')}>
                      Reading
                  </Link>
                  <Typography variant='body1' sx={{display:'flex', flexDirection:'row'}}>
                      <Typography sx={{fontWeight:550, mr:1}}>Questions: </Typography> 28
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  {readingScore!=='' && (
                    <Typography sx={{ color: readingScore >= 80 ? 'green' : 'red', fontWeight: 'bold' }}>
                      {readingScore >= 80 ? 'PASS' : 'FAIL'}
                    </Typography>
                  )}
                  {readingScore!=='' && <Typography sx={{ mb: 1 }}>{readingScore + '%'}</Typography>}
                  {!readingGraded && (<BasicModal title={submitTitle} subText={submitSubText} buttonFunction={submitReadingComponent} buttonText={submitButtonText} buttonStlye={submitStyle}></BasicModal>)}
                </Box>
              </Box>
          </Box>  
        </Stack>        
      </Box>
    </Box>

  )
};
    
export default CVESDIAComponents;